export default "__VITE_ASSET__Bs7_9sX3__"